import React from 'react';
import '../../scss/components/_horizontal-video-card.scss'



const HorizontalVideoCard = props => (
    <div className={`full-width-video-card backgroundGradientContainer${props.cardColor}`}>
        <div className="image-container">
            <a href={props.readMoreLink} target="_blank">
                <div className="icon">
                    <img src={'/press/play.svg'} alt="Play icon"/>
                </div>
                <div style={imgUrl(props.imgUrl)} className="video-image"></div>
            </a>
        </div>
        <div className="video-text">
            <h2>{props.title}</h2>
            <p className="video-description">{props.description}</p>
            <p className="video-read-more mb-0"><a href={props.readMoreLink} target="_blank" className="ctaStandard"> {props.readMoreText} </a></p>
        </div>
    </div>
);

const imgUrl = (urlImg) => ({
    backgroundImage : `url(${urlImg})`,
})

export default HorizontalVideoCard;
    